import { ApiProperty } from '@nestjs/swagger';
export class StockItemRequest {
    @ApiProperty()
    saleOrderId: number;
    @ApiProperty()
    itemCategoryId?: number;
    @ApiProperty()
    itemId: number;
    @ApiProperty()
    unitId?: number;
    @ApiProperty()
    role?: string;
    @ApiProperty()
    againstSO?: boolean
}

